import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function IpMenu() {
    const MenuCard = ({link, title, icon, color}) => (
        <div className="col-xl-3 col-lg-4 col-md-6 mb-4">

            <Link to={link} className="menu-link">

                <div className="menu-card" style={{borderTop: `4px solid ${color}`}}>

                    <div className="menu-icon" style={{color: color}}>
                        <FontAwesomeIcon icon={icon} size="2x"/>
                    </div>

                    <p className="menu-title">{title}</p>

                </div>

            </Link>

        </div>
    );
    return (
        <section className="container-fluid mt-4">

            <h5 className="menu-section-title">IP Admission</h5>

            <div className="row">

                <MenuCard link="/ip-admit" title="Admission" icon="fa-solid fa-bed-pulse" color="#0d6efd"/>
                <MenuCard link="/ip-list" title="IP List" icon="fa-solid fa-list" color="#20c997"/>
                <MenuCard link="/ip-wait-list" title="Waiting List" icon="fa-solid fa-clock" color="#6f42c1"/>
                <MenuCard link="/bill-list" title="Billing Summary" icon="fa-solid fa-file-invoice" color="#fd7e14"/>
                <MenuCard link="/discharge-list-date" title="Discharge List" icon="fa-solid fa-file-waveform"
                          color="#dc3545"/>

            </div>

            <h5 className="menu-section-title">Insurance</h5>

            <div className="row">

                <MenuCard link="/insur-type" title="Insurance Type" icon="fa-solid fa-shield" color="#0dcaf0"/>
                <MenuCard link="/insur-cmpy" title="Insurance Company" icon="fa-solid fa-building" color="#6610f2"/>
                <MenuCard link="/preauth-list" title="Pre Auth List" icon="fa-solid fa-file-medical" color="#ffc107"/>

            </div>

            <h5 className="menu-section-title">Room Management</h5>

            <div className="row">

                <MenuCard link="/room-type" title="Room Type" icon="fa-solid fa-door-open" color="#198754"/>
                <MenuCard link="/room-no" title="Room Number" icon="fa-solid fa-bed" color="#dc3545"/>
                <MenuCard link="/view-room" title="Room Status" icon="fa-solid fa-hospital" color="#0d6efd"/>

            </div>

            <h5 className="menu-section-title">IP Reports</h5>

            <div className="row">

                <MenuCard link="/payment-detail-ip" title="Payment Detail" icon="fa-solid fa-money-check"
                          color="#0d6efd"/>
                <MenuCard link="/insur-report" title="Insurance Report" icon="fa-solid fa-shield-heart"
                          color="#20c997"/>
                <MenuCard link="/admit-list-date" title="Admission Report" icon="fa-solid fa-bed-pulse"
                          color="#6f42c1"/>
                <MenuCard link="/discharge-list-date" title="Discharge Report" icon="fa-solid fa-file-waveform"
                          color="#fd7e14"/>
                <MenuCard link="/ip-refund-report" title="Refund Report" icon="fa-solid fa-rotate-left"
                          color="#dc3545"/>


            </div>

        </section>
    )
}
export default IpMenu;